import Marquee from "@/components/ui/marquee";
import { GoalCard } from "@/components/cards/goals/GoalCard";
import type { Goal } from "instantdb/types";
import { HEALTH_AREA_MAPPING } from "@/seed/HealthAreaMapping";

interface ProgressGoalCardsProps {
  categorySlug: string;
}

export function ProgressGoalCards({ categorySlug }: ProgressGoalCardsProps) {
  const healthArea = Object.values(HEALTH_AREA_MAPPING).find(
    (category) => category.slug === categorySlug,
  );
  const goals = (healthArea?.goals ?? []).slice(0, 3);

  return (
    <div className="flex flex-col h-[240px] md:h-[420px] overflow-hidden md:overflow-visible bg-gradient-to-r from-green-100 to-teal-100 dark:from-green-900/30 dark:to-teal-900/30">
      <div className="flex-1 relative overflow-hidden rounded-lg">
        <Marquee vertical reverse className="flex items-center" duration="[--duration:20s]">
          {goals.map((goal) => (
            <div key={goal.title} className="w-[320px] @[1080px]:w-[480px]">
              <GoalCard onHome goal={goal as Goal} />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
}
